import React, {useEffect, useRef, useState} from 'react';
import {Handle, Position} from "react-flow-renderer";

const TextArea = ({data, type, isFocused}) => {
    //
    // const [isvVisSelectName, setVisSelectName] = useState(false)
    // const [ShowSelect, setShowSelect] = useState(false)
    const [name, setName] = useState('')

    const textArea = useRef()

    useEffect(() => {
        if (!isFocused && textArea) {
            //setShowSelect(false)

            data.size.width = textArea.current.style.width.match(/\d+/)[0]
            data.size.height = textArea.current.style.height.match(/\d+/)[0]

        }
    }, [isFocused])

    useEffect(() => {
        setName(data.title)


        // textArea.current.style.cssText = "width:500px; height:500px;"

    }, [])

    useEffect(() => {
        data.title = name

    }, [name])

    useEffect(() => {
        data.textAreaRef = textArea.current
    }, [])


    const placeholder = type === "Main" ? "MAIN NODE" : type === "Npc" ? "NPC NODE" : type === "Player" ? "PLAYER NODE" :
        type === "GlobalData" ? "GLOBAL DATA NODE" : "Node"


    return (
        <div style={{
            position: "relative",
            marginBottom: "4px"
        }}>

            {(type !== "GlobalData") && <Handle className="MainIne" type="target" id="in" position={Position.Left}/>}
            {(type === "Npc" || type === "Player") &&
                <Handle className="MainOute" type="source" id="out" position={Position.Right}/>}
            <div style={{display: "flex", flexDirection: "column"}}>


                {type !== "GlobalData" && <input
                    onMouseEnter={e => {
                       // setVisSelectName(true)
                    }}

                    onMouseLeave={() => {
                       // setVisSelectName(false)
                    //    setShowSelect(false)
                    }}

                    placeholder={placeholder}

                    value={name}
                    onChange={(event) => {
                        data.title = event.target.value
                        setName(event.target.value)
                    }}

                    style={{
                        background: "transparent", color: "white", textAlign: "center", border: "none", outline: "none",
                        marginTop: "3px", width: "auto"
                    }} type="text"/>}


                {/*{isvVisSelectName && <button*/}
                {/*    onClick={() => {*/}
                {/*        setShowSelect(true)*/}
                {/*    }}*/}

                {/*    onMouseEnter={e => {*/}
                {/*        setVisSelectName(true)*/}
                {/*    }}*/}
                {/*    onMouseLeave={() => {*/}
                {/*        setVisSelectName(false)*/}

                {/*    }}*/}

                {/*    className="battonChoseName">*/}
                {/*    <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" filter="invert(99%)"*/}
                {/*    >*/}
                {/*        <path*/}
                {/*            d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"></path>*/}
                {/*    </svg>*/}
                {/*</button>}*/}

                {/*{ShowSelect && <SelectName ShowMenu={setShowSelect} setName={setName}/>}*/}

                {/*<label htmlFor="text">Text:</label>*/}
                <textarea

                    onClick={() => {
                        if (type === "Player" || type === "Npc") {
                            data.data.forEach((value) => {
                                value.setIsOpen(false)
                            })
                        }
                    }}
                    placeholder= {type ==="GlobalData"? "GLOBAL DATA:" :"Double click to add content..."}
                    ref={textArea}
                    style={{width: `${data.size.width}px`, height: `${data.size.height}px`}}
                    spellCheck={true}
                    onChange={(event) => data.text = event.target.value}
                    className="TextArea" id="TextArea" type='text'
                    defaultValue={data.text}></textarea>
            </div>
        </div>
    );
};

export default TextArea;

// borderBottom:"1px solid #7a7a7a"